export const PRODUCTS = [
  {
    slug: "zelvoria-lavender",
    name: "Zelvoria Lavender",
    fragrance: "Lavender",
    category: "Scented Candle",
    price: 899,
    rating: 4.8,
    reviews: 124,
    image: "/images/candle-lavender.jpg",
    gallery: ["/images/candle-lavender.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "Hand-poured serenity. French lavender folded into a slow-burning botanical wax blend, made for quiet evenings and unhurried mornings.",
    notes: { top: "Fresh lavender, bergamot", heart: "Lavender blossom, soft herbs", base: "Warm musk, tonka" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
  {
    slug: "zelvoria-vanilla",
    name: "Zelvoria Vanilla",
    fragrance: "Vanilla",
    category: "Scented Candle",
    price: 999,
    rating: 4.9,
    reviews: 212,
    image: "/images/candle-vanilla.jpg",
    gallery: ["/images/candle-vanilla.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "A warm embrace in glass. Madagascar vanilla orchid and cream, poured slowly for rooms that feel like Sunday afternoon.",
    notes: { top: "Vanilla orchid, sweet cream", heart: "Tonka bean, heliotrope", base: "Sandalwood, amber" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
  {
    slug: "zelvoria-sandalwood",
    name: "Zelvoria Sandalwood",
    fragrance: "Sandalwood",
    category: "Scented Candle",
    price: 1099,
    rating: 4.9,
    reviews: 186,
    image: "/images/candle-sandalwood.jpg",
    gallery: ["/images/candle-sandalwood.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "Mysore sandalwood, meditative and warm. A scent that turns any room into a sanctuary of calm and quiet devotion.",
    notes: { top: "Cardamom, soft spice", heart: "Mysore sandalwood, cedar", base: "Vetiver, warm amber" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
  {
    slug: "zelvoria-oud",
    name: "Zelvoria Oud",
    fragrance: "Oud",
    category: "Scented Candle",
    price: 1299,
    rating: 5.0,
    reviews: 96,
    image: "/images/candle-oud.jpg",
    gallery: ["/images/candle-oud.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "Our most opulent pour. Rare oud, smoked woods and dark amber — an evening scent of depth, mystery and quiet power.",
    notes: { top: "Smoked oud, saffron", heart: "Rosewood, dark resin", base: "Leather, black amber" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
  {
    slug: "zelvoria-rose",
    name: "Zelvoria Rose",
    fragrance: "Rose",
    category: "Scented Candle",
    price: 999,
    rating: 4.7,
    reviews: 88,
    image: "/images/candle-rose.jpg",
    gallery: ["/images/candle-rose.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "Damask rose at first light — soft, powdery and romantic, without ever raising its voice.",
    notes: { top: "Damask rose, dewy petals", heart: "Peony, lychee", base: "Soft musk, cedarwood" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
  {
    slug: "zelvoria-jasmine",
    name: "Zelvoria Jasmine",
    fragrance: "Jasmine",
    category: "Scented Candle",
    price: 949,
    rating: 4.8,
    reviews: 102,
    image: "/images/candle-jasmine.jpg",
    gallery: ["/images/candle-jasmine.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "Night-blooming jasmine strung like a garland through warm air — tender, luminous and unmistakably Indian.",
    notes: { top: "Green leaves, neroli", heart: "Jasmine sambac, tuberose", base: "White musk, sandal" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
  {
    slug: "zelvoria-cedarwood",
    name: "Zelvoria Cedarwood",
    fragrance: "Cedarwood",
    category: "Scented Candle",
    price: 1099,
    rating: 4.6,
    reviews: 64,
    image: "/images/candle-cedarwood.jpg",
    gallery: ["/images/candle-cedarwood.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "Dry cedar and sun-warmed timber. Grounded, architectural, quietly confident — the scent of a well-kept library.",
    notes: { top: "Cypress, clary sage", heart: "Cedarwood, pine resin", base: "Vetiver, soft smoke" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
  {
    slug: "zelvoria-amber",
    name: "Zelvoria Amber",
    fragrance: "Amber",
    category: "Scented Candle",
    price: 1199,
    rating: 4.9,
    reviews: 77,
    image: "/images/candle-amber.jpg",
    gallery: ["/images/candle-amber.jpg", "/images/lifestyle.jpg", "/images/collection.jpg"],
    description:
      "Golden amber and honeyed resins, glowing low and long. Warmth you can almost touch.",
    notes: { top: "Golden amber, bergamot", heart: "Labdanum, honey", base: "Vanilla, benzoin" },
    burnTime: "Approximately 30–40 hours",
    wax: "Premium soy–paraffin blend",
  },
];

export const COLLECTIONS = [
  {
    slug: "candles",
    name: "Zelvoria Candles",
    status: "available",
    path: "/candles",
    tagline: "More than just a candle. It's a feeling.",
    image: "/images/collection.jpg",
  },
  {
    slug: "jewellery",
    name: "Zelvoria Jewellery",
    status: "coming-soon",
    path: "/jewellery",
    tagline: "Elegant pieces for life's special moments.",
    image: "/images/jewellery.jpg",
  },
  {
    slug: "fashion",
    name: "Zelvoria Fashion",
    status: "coming-soon",
    path: "/fashion",
    tagline: "Timeless styles for the modern you.",
    image: "/images/fashion.jpg",
  },
];

export const FREE_SHIPPING_THRESHOLD = 1499;
export const SHIPPING_FEE = 99;

export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const findProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export function searchAll(q) {
  const query = q.trim().toLowerCase();
  if (!query) return { products: [], collections: [] };
  const products = PRODUCTS.filter((p) =>
    [p.name, p.fragrance, p.category].join(" ").toLowerCase().includes(query)
  );
  const collections = COLLECTIONS.filter(
    (c) => c.name.toLowerCase().includes(query) || c.slug.includes(query)
  );
  return { products, collections };
}
